import { render, staticRenderFns } from "./StepDistributionMode.vue?vue&type=template&id=b9124fb0&scoped=true&"
import script from "./StepDistributionMode.vue?vue&type=script&lang=ts&"
export * from "./StepDistributionMode.vue?vue&type=script&lang=ts&"
import style0 from "./StepDistributionMode.vue?vue&type=style&index=0&id=b9124fb0&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9124fb0",
  null
  
)

export default component.exports